module.exports = __webpack_public_path__ + "img/logo.88a9309d.svg";